module.exports = require("unist-util-select");


//////////////////
// WEBPACK FOOTER
// external "unist-util-select"
// module id = 4
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13 14